import React, { PropTypes, Component } from 'react';
import { BundleActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import BundleDetail from 'components/Route/Bundle/Detail';
import { BundleStore } from 'stores';
import { history } from 'helpers';

class BundleDetailContainer extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(BundleStore);
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    BundleActions.findById(this.props.params.bundleId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.routeParams.bundleId !== nextProps.routeParams.bundleId) {
      BundleActions.findById(nextProps.routeParams.bundleId);
    }
  }

  goBack() {
    history.push(`/bundles`);
  }

  render() {
    const { selected } = this.state;
    return <BundleDetail bundle={selected} onClose={::this.goBack} />;
  }
}

export default BundleDetailContainer;



// WEBPACK FOOTER //
// ./src/js/components/Route/Bundle/BundleDetailContainer.js